import { createAction, props } from "@ngrx/store";
import { InternalTransferInputRequest } from "../models/internal-transfer/InternalTransferInputRequest";
import { InternalTransferInputResponse } from "../models/internal-transfer/InternalTransferInputResponse";
import { InternalTransferInquiryResponse } from "../models/internal-transfer/InternalTransferInquiryResponse";
import { InternalTransferPositionsResponse } from "../models/internal-transfer/InternalTransferPositionsResponse";
import { ServiceError, ServiceErrorWithList } from "../models/shared/ServiceError";
import { RowDataById } from "../models/internal-transfer/InternalTransfersInfo";
import { InternalTransferListVerifyResponse } from "../models/internal-transfer/InternalTransferVerifyResponse";
import { InternalTransferListAcknowledgeResponse } from "../models/internal-transfer/InternalTransferAcknowledgeResponse";

export const itToAccountEntered = createAction(
    '[Create Request - Internal Transfers] To Account Entered',
    props<{ payload: InternalTransferInputRequest, toAccount: string }>()
);

export const itExtraPromptUpdated = createAction(
    '[Create Request - Internal Transfers] Extra prompt updated'
);

export const itLoadToAccountSuccess = createAction(
    '[Create Request - Internal Transfer] To Account Successfully loaded',
    props<{ internalTransferInputResponse: InternalTransferInputResponse }>()
);
export const itLoadToAccountFinishedWithError = createAction(
    '[Create Request - Internal Transfers] Load to account has error',
    props<{ internalTransferInputResponse: InternalTransferInputResponse }>()
);

export const itInquiryCallSuccessful = createAction(
    '[Create Request - Internal Transfers] Inquiry call successful',
    props<{ index: number, internalTransferInquiryResponse: InternalTransferInquiryResponse }>()
);

export const itInquiryCallFail = createAction(
    '[Create Request - Internal Transfers] Inquiry call failed',
    props<{ index: number, ServiceError: ServiceError }>()
);

export const itLoadToAccountFail = createAction(
    '[Create Request - Internal Transfers] Error loading To Account',
    props<{ index: number, ServiceError: ServiceError }>()
);

export const itUpdateRowData = createAction(
    '[Update Request - Positions Table] Update multiple to account positions table value',
    props<RowDataById>()
);

export const itLoadPositions = createAction(
    '[Create Request - Internal Transfers] Calling endpoint to get positions'
);

export const updateFrequencyIT = createAction(
    '[Create Request - Transaction Form] Update Frequency Radio Internal Transfers'
);

export const itLoadPositionsFail = createAction(
    '[Create Request - Internal Transfers] Call to get positions failed',
    props<ServiceError>()
);

export const itLoadPositionsSuccessful = createAction(
    '[Create Request - Internal Transfers] Call to get positions successfully loaded',
    props<{ internalTransferPositionsResponse: InternalTransferPositionsResponse }>()
);

export const itTransactionDetailsComponentLoaded = createAction(
    '[Create Request - Internal Transfers] Transaction Details Component Loaded'
);

export const itClearToAccount = createAction(
    '[Create Request - Internal Transfers] Clear to account',
    props<{ account: string }>(),
);
export const itClearToAccounts = createAction(
    '[Create Request - Internal Transfers] Clear to accounts'
);

export const verifyListCallFinishedWithError = createAction(
    '[Create Request - Internal Transfers] Verify List call finished with error',
    props<{response: InternalTransferListVerifyResponse}>()
);

export const verifyListCallSuccessful = createAction(
    '[Create Request - Internal Transfers] Verify List call successful',
    props<{response: InternalTransferListVerifyResponse}>()
);

export const verifyListCallFailed = createAction(
    '[Create Request - Internal Transfers] Verify List call failed',
    props<ServiceError>()
);
export const callAcknowledgeList = createAction(
    '[Create Request - Internal Transfers] Call to internal transfer acknowledge'
);

export const acknowledgeListCallSuccessful = createAction('[Create Request - Internal Transfer] Call to internal transfer acknowledge list was successful',
    props<{ response: InternalTransferListAcknowledgeResponse }>()
);

export const acknowledgeListCallFail = createAction(
    '[Create Request - Internal Transfer] Call to internal transfer acknowledge failed',
    props<ServiceErrorWithList>()
);